import React, { Component } from "react"
import { NavLink } from "react-router-dom"



export class FormTable extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount(){
    }
    render() {
        const { name, gender, email, fbID, photoURL, uid, userAgreementAcceptedTime} = this.props.values
        const idx = this.props.idx
        return (
            <tr className="odd">
                <td>{idx}</td>
                <td>
                    <img style={{borderRadius:"100%"}} src ={photoURL} />
                </td>
                <td>{name}</td>
                <td>{email}</td>
                <td><a href={`https://www.facebook.com/${fbID}`}>{fbID}</a></td>
                <td>{uid}</td>
                <td>{userAgreementAcceptedTime}</td>

                <td>
                    <NavLink to={`/mangarmangaagiinadmin/users/${uid}/update/`} className="text-success">
                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </NavLink>
                </td>
                <td>
                    <a href="#" className="text-danger">
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </a>
                </td>
            </tr>
        )

    }

}
